/** Raport zarządu — złożenie słowników sekcji pod `mbr.*` (plik FUNDAMENTU; sekcje edytują tylko swój `mbr-<sekcja>.ts`). */
import { mbrChecksEn, mbrChecksPl, mbrCommonEn, mbrCommonPl } from './mbr-common';
import { mbrCloseEn, mbrClosePl } from './mbr-close';
import { mbrCustomersEn, mbrCustomersPl } from './mbr-customers';
import { mbrFinanceEn, mbrFinancePl } from './mbr-finance';
import { mbrLogisticsEn, mbrLogisticsPl } from './mbr-logistics';
import { mbrOperationsEn, mbrOperationsPl } from './mbr-operations';
import { mbrReportEn, mbrReportPl } from './mbr-report';
import { mbrSalesEn, mbrSalesPl } from './mbr-sales';

export const mbrPl = {
  common: mbrCommonPl,
  checks: mbrChecksPl,
  report: mbrReportPl,
  sales: mbrSalesPl,
  customers: mbrCustomersPl,
  logistics: mbrLogisticsPl,
  operations: mbrOperationsPl,
  finance: mbrFinancePl,
  close: mbrClosePl,
};

export const mbrEn = {
  common: mbrCommonEn,
  checks: mbrChecksEn,
  report: mbrReportEn,
  sales: mbrSalesEn,
  customers: mbrCustomersEn,
  logistics: mbrLogisticsEn,
  operations: mbrOperationsEn,
  finance: mbrFinanceEn,
  close: mbrCloseEn,
};
